import { StandardLayout } from "common/layouts/StandardLayout";
import React from "react";
import { Route, Switch } from "react-router-dom";
import { GoalShowPageContainer } from "../GoalShowPage";
import { UserGoalsPageContainer } from "../UserGoalsPage";

const GoalEditPage = (props) => <GoalShowPageContainer {...props} editing />;

export const routes = ({ match: { path } }) => (
  <StandardLayout greyBg>
    <Switch>
      <Route path={`${path}/`} exact component={UserGoalsPageContainer} />
      <Route path={`${path}/new`} component={UserGoalsPageContainer} />
      <Route path={`${path}/:goalId/edit`} component={GoalEditPage} />
      <Route path={`${path}/:goalId`} component={GoalShowPageContainer} />
    </Switch>
  </StandardLayout>
);
